import React from "react";
import { PolicyLayout, H2 } from "./PolicyLayout";

const PrivacyPolicy = () => (
  <PolicyLayout
    title="Privacy Policy – Revibe Health And Happiness"
    updated="22 July 2026"
  >
    <H2>1. Data Controller</H2>
    <p>
      REVIBE HEALTH AND HAPPINESS, Partnership Firm, 2206, 22nd Floor, Solus,
      Hiranandani Estate, Patlipada, Thane, MH 400607. GSTIN: 27ABLFR6155M1ZH.
    </p>

    <H2>2. Information We Collect</H2>
    <p>
      Name, Mobile Number, Email Address, City, IP Address, Webinar Attendance
      Status.
    </p>

    <H2>3. Purpose & Consent for Communication</H2>
    <p>
      By registering for any webinar on swapnilgautam.com, you expressly agree
      and consent that:
    </p>
    <p>
      a) Revibe Health And Happiness and Swapnil Gautam’s team may contact you
      via WhatsApp on +91-9967756867, SMS, or phone calls.
    </p>
    <p>
      b) Purposes include: registration confirmation, webinar reminders,
      follow-up if you miss a session, invitations to future webinars, and
      promotions for our health programs, diet plans, and related products.
    </p>
    <p>
      c) If you do not attend the webinar on your registered date, our team
      will contact you via WhatsApp/call with the link and timing for the next
      available webinar.
    </p>

    <H2>4. WhatsApp Communication Details</H2>
    <p>Official WhatsApp Number: +91-9967756867</p>
    <p>
      Message Frequency: 2-5 messages per week while you are an active
      registrant/lead.
    </p>
    <p>
      Opt-out: Reply STOP to any WhatsApp message or email
      support@swapnilgautam.com.
    </p>

    <H2>5. Data Sharing</H2>
    <p>
      To deliver WhatsApp messages, your name and phone number are shared with
      Meta Platforms Inc. via WhatsApp Business API. We do not sell your data.
    </p>

    <H2>6. Data Retention</H2>
    <p>
      We retain your data for 24 months from last interaction or until you
      request deletion.
    </p>

    <H2>7. Your Rights</H2>
    <p>
      Email privacy@swapnilgautam.com to access, correct, or delete data.
    </p>

    <H2>8. Grievance Officer</H2>
    <p>
      Swapnil Gautam, Partner
      <br />
      Email: grievance@swapnilgautam.com | Phone: +91-9967756867
      <br />
      Address: 2206, 22nd Floor, Solus, Hiranandani Estate, Thane 400607
    </p>

    <H2>9. Updates</H2>
    <p>Changes posted here. Continued use means acceptance.</p>
  </PolicyLayout>
);

export default PrivacyPolicy;
